<module-container>
  <div class="title-container">
    <h2>Default Store Type Settings</h2>
  </div>
  <abcis-table [configuration]="tableConfig"></abcis-table>
</module-container>
